import { render, staticRenderFns } from "./VerifyEmailNotice.vue?vue&type=template&id=58d379ec&scoped=true&"
import script from "./VerifyEmailNotice.vue?vue&type=script&lang=ts&"
export * from "./VerifyEmailNotice.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyEmailNotice.vue?vue&type=style&index=0&id=58d379ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d379ec",
  null
  
)

export default component.exports